import { KontoausgleicheArt } from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import {
  faCalendarCircleMinus,
  faCalendarCirclePlus,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function KontoausgleichsArtSelection({
  value,
}: {
  value: KontoausgleicheArt;
}) {
  return (
    <div>
      {value === KontoausgleicheArt.FEIERTAGSAUSZAHLUNG ? (
        <div>
          <FontAwesomeIcon
            icon={faCalendarCircleMinus}
            className="text-secondary-purple-500"
          />
          {value}
        </div>
      ) : (
        <div>
          <FontAwesomeIcon
            icon={faCalendarCirclePlus}
            className="text-brand-red-200"
          />
          {value}
        </div>
      )}
    </div>
  );
}
